import { ErrorComponent } from './error/error.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HelpCenterComponent } from './help-center/help-center.component';
import { ActiveGuard, AuthGuard } from './_guards/index';
import { HelpTopicsComponent } from './help-topics/help-topics.component';
import { QuickLinksComponent } from './quick-links/quick-links.component';
import { LandingComponent } from './landing/landing.component';
import { SearchResultComponent } from './search-result/search-result.component';
import { ViewArticlesComponent } from './view-articles/view-articles.component';
import { ForgotpasswordComponent } from './forgotpassword/forgotpassword.component';
import {PasswordresetComponent} from './passwordreset/passwordreset.component';
import { PwdresetEmailComponent } from './pwdreset-email/pwdreset-email.component';
import {ModifyPasswordComponent} from './modify-password/modify-password.component';
import { BrowseComponent } from './browse/browse.component';
import { ArticleViewComponent } from './article-view/article-view.component';
import { KbArticlesComponent } from './kb-articles/kb-articles.component';
import { SearchArticlesComponent } from './search-articles/search-articles.component';
import {SurveyCreationComponent} from './survey-creation/survey-creation.component';
import { SsoLoginComponent } from './sso-login/sso-login.component';
import { TrackerComponent } from './tracker/tracker.component';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';


export const routes: Routes = [

  
  {
    path: ':shortname', component: LandingComponent, canActivate: [ActiveGuard],
    children: [
      { path: 'home', component: HomeComponent },
      { path: 'helptopics', component: HelpTopicsComponent },
      { path: 'articles', component: HelpTopicsComponent },
      { path: 'login', component: LoginComponent },
      { path: 'forgotPassword', component: ForgotpasswordComponent },
      { path: 'helpcenter', component: HelpCenterComponent },
      { path: 'searchresults', component: SearchResultComponent },
      { path: 'viewarticles', component: ViewArticlesComponent },
      { path: 'passwordreset',component:PasswordresetComponent},
      { path: 'pwdreset-email',component:PwdresetEmailComponent},
      { path: 'browse',component:BrowseComponent},
      { path: 'article',component:ArticleViewComponent},
      { path: 'kb',component:KbArticlesComponent}  ,
      { path :'search',component:SearchArticlesComponent},
      { path:  'survey',component:SurveyCreationComponent},
      { path: 'ssologin', component:SsoLoginComponent},
      { path: 'tracker', component: TrackerComponent },
    ]
  },
  { path: ':shortname/error', component: ErrorComponent },
  // otherwise redirect to home
  { path: '**', redirectTo: ':shortname/home' }

];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
